/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { ChartData } from '../../../charts/models/ChartData';
import { CustomItemContext } from 'app/components/data-table/data-table.component';

@Component({
  selector: 'app-viewability',
  templateUrl: './app-viewability.component.html',
  styleUrls: ['./app-viewability.component.css'],
  inputs: ['data']
})
export class AppViewabilityComponent implements OnInit, OnChanges {
  @ViewChild('lockedTemplate', { static: true })
  lockedTemplate: TemplateRef<CustomItemContext>;

  @Input() domain;
  @Input() appName;
  @Input() isFreemium: boolean;

  data: any;
  toggle = false;

  headers = [];
  adSizes = [];
  percPipe = new PercPipe();
  lineChartData: Array<ChartData>;

  ngOnInit() {
    this.headers = [];
    this.headers.push({
      class: 'col-4',
      text: 'TOP AD SIZE',
      key: 'adSize',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col',
      text: 'CONTRIBUTION',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col',
      text: 'EST. VIEWABILITY%',
      key: 'viewability',
      tooltipkey: ''
    });
  }

  toggleShow() {
    this.toggle = !this.toggle;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      const { adSizes, byMonth } = this.data.viewabilityDistribution;

      this.adSizes = JSON.parse(JSON.stringify(adSizes));

      for (const adSize of this.adSizes) {
        const totalInventoryRatio = adSize['totalInventoryRatio'];
        adSize['totalInventoryRatio'] = this.percPipe.transform(
          totalInventoryRatio,
          '1.2-2'
        );
        const viewability = adSize['viewability'];
        adSize['viewability'] = this.percPipe.transform(viewability, '1.2-2');
        const nonGivtSivtViewability = adSize['nonGivtSivtViewability'];
        adSize['nonGivtSivtViewability'] = this.percPipe.transform(
          nonGivtSivtViewability,
          '1.2-2'
        );

        if (this.isFreemium) {
          // TODO: Check if this should only be for Anon
          adSize['totalInventoryRatioTemplate'] = this.lockedTemplate;
          adSize['viewabilityTemplate'] = this.lockedTemplate;
          adSize['nonGivtSivtViewabilityTemplate'] = this.lockedTemplate;
        }
      }

      if (byMonth) {
        this.lineChartData = byMonth;
        this.lineChartData.reverse();
      }
    }
  }
}
